module.exports = __webpack_public_path__ + "static/media/team4.ef149a1b.png";